function enhanceMemysArticle(article) {
  const content = article.querySelector('.blog-post-content rte-formatter');
  if (!content || content.dataset.memysBlogEnhanced === 'true') return;
  content.dataset.memysBlogEnhanced = 'true';
  const container = content.querySelector('.memys-freshness-guide, .memys-classification-v3, .memys-editorial-article') || content;
  const hasExistingIndex = Boolean(content.querySelector('nav a[href^="#"], .memys-mobile-index'));
  const headings = [...content.querySelectorAll('h2')].filter(heading => !/fuentes|referencias/i.test(heading.textContent) && !heading.closest('aside, .memys-cta, .memys-sources'));
  const firstParagraph = [...container.children].find(element => element.tagName === 'P' && !element.querySelector('small'));
  const essentialParagraph = [...container.children].find(element => element.tagName === 'P' && /^lo esencial:/i.test(element.textContent.trim()));
  const summary = essentialParagraph || firstParagraph;
  if (summary && !content.querySelector('.memys-index')) {
    summary.classList.add('memys-blog-summary');
    if (!essentialParagraph) {
      const label = document.createElement('span');
      label.className = 'memys-blog-summary__label';
      label.dataset.memysBlogGenerated = 'true';
      label.textContent = article.dataset.summaryLabel;
      summary.prepend(label);
    }
  }
  headings.forEach((heading, index) => {
    if (!heading.id) {
      let id = `memys-guide-${article.dataset.articleId}-${index + 1}`;
      while (document.getElementById(id)) id += '-section';
      heading.id = id;
    }
    const marker = document.createElement('span');
    marker.className = 'memys-blog-section-number';
    marker.dataset.memysBlogGenerated = 'true';
    marker.setAttribute('aria-hidden', 'true');
    marker.textContent = String(index + 1).padStart(2, '0');
    heading.before(marker);
    if (/comprar|recibir/i.test(heading.textContent)) {
      let sibling = heading.nextElementSibling;
      while (sibling && !/^H[23]$/.test(sibling.tagName)) {
        if (sibling.tagName === 'UL') sibling.classList.add('memys-blog-checklist');
        sibling = sibling.nextElementSibling;
      }
    }
  });
  if (!hasExistingIndex && headings.length >= 2) {
    const toc = document.createElement('details');
    toc.className = 'memys-blog-toc';
    toc.dataset.memysBlogGenerated = 'true';
    toc.open = matchMedia('(min-width: 750px)').matches;
    const toggle = document.createElement('summary');
    toggle.textContent = article.dataset.contentsLabel;
    const list = document.createElement('ol');
    headings.forEach(heading => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
    toc.append(toggle, list);
    const firstMarker = headings[0].previousElementSibling;
    (firstMarker || headings[0]).before(toc);
  }
  [...content.querySelectorAll('h3')].forEach(heading => {
    if (heading.closest('details') || !/^[¿]|[?]$/.test(heading.textContent.trim())) return;
    const sectionHeading = [...headings].reverse().find(section => section.compareDocumentPosition(heading) & Node.DOCUMENT_POSITION_FOLLOWING);
    if (!sectionHeading || !/preguntas|frecuentes|faq|resolvemos.*dudas/i.test(sectionHeading.textContent)) return;
    const answerNodes = [];
    let sibling = heading.nextSibling;
    while (sibling && !(sibling.nodeType === Node.ELEMENT_NODE && /^H[123]$/.test(sibling.tagName))) {
      if (sibling.nodeType === Node.ELEMENT_NODE && sibling.querySelector('a[href^="/collections/"], a[href^="/products/"], a[href^="/pages/"]')) break;
      answerNodes.push(sibling);
      sibling = sibling.nextSibling;
    }
    if (!answerNodes.some(node => node.textContent.trim())) return;
    const question = document.createElement('details');
    question.className = 'memys-blog-question';
    const toggle = document.createElement('summary');
    const answer = document.createElement('div');
    answer.className = 'memys-blog-answer';
    heading.before(question);
    toggle.append(heading);
    answerNodes.forEach(node => answer.append(node));
    question.append(toggle, answer);
  });
  content.querySelectorAll('p').forEach(paragraph => {
    if (paragraph.closest('.memys-blog-answer')) return;
    if (paragraph.querySelector('a[href^="/blogs/"]') && paragraph.querySelector('a[href^="/collections/"]')) {
      paragraph.classList.add('memys-blog-next');
    }
  });
}
function initMemysBlogDesign(root = document) {
  root.querySelectorAll('[data-memys-blog-design]').forEach(enhanceMemysArticle);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initMemysBlogDesign(), {once: true});
} else {
  initMemysBlogDesign();
}
document.addEventListener('shopify:section:load', event => initMemysBlogDesign(event.target));
